import { TaskStatusEnum } from "enums/TaskStatusEnum";
import { formatDate } from "helpers";
import { createLogger } from "logging";
import { PatchTaskModel } from "models/PatchTaskModel";
import { TaskModel } from "models/TaskModel";
import { createContext } from "react";
import { UseFormReturn } from "react-hook-form";

const logger = createLogger("EditTaskContext");

export interface TaskFieldValues {
  title: string;
  assignedToId: number;
  startDate: string;
  dueDate: string;
  description: string;
  status: TaskStatusEnum;
  source: string;
}

export function getTaskFieldValues(task: TaskModel): TaskFieldValues {
  const title = task.title || "";
  const assignedToId = task.assignedTo?.id || 0;
  const startDate = formatDate(task.created);
  const dueDate = formatDate(task.dueDate);
  const description = task.description || "";
  const status = task.isDeleted ? TaskStatusEnum.Deleted : task.status;
  const source = task.source || "";

  const values = {
    title,
    assignedToId,
    startDate,
    dueDate,
    description,
    status,
    source,
  };
  logger.debug(`getTaskFieldValues(): `, values);
  return values;
}

export interface EditTaskContextProps {
  confirmTaskUnsaved: boolean;
  setConfirmTaskUnsaved: (newState: boolean) => void;
  editTaskId: number;
  setEditTaskId: (id: number) => void;
  isLoading: boolean;
  isDirty: boolean;
  isValid: boolean;
  isSubmittable: boolean;
  isSubmitting: boolean;
  form: UseFormReturn<TaskFieldValues>;
  getPatch: (values: TaskFieldValues) => PatchTaskModel;
  handleSave: () => Promise<void>;
  handleClose: (ignoreDirty?: boolean) => void;
}

export const EditTaskContext = createContext({} as EditTaskContextProps);
